import { QUERY_KEYS } from "@/libraries/constant";
import { isAuthenticating } from "@/libraries/helper";
import { memberProfileQueryOptions } from "@/queries";
import { onlineManager } from "@tanstack/react-query";
import type { RouteContext } from "@tanstack/react-router";

export async function getProfileLoader(ctx: RouteContext) {
	if (!isAuthenticating()) return undefined;
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureQueryData(memberProfileQueryOptions());
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_MEMBER_PROFILE]);
}
